/*
* CM
* SD-WAN
* 기본설정 프로파일
*
*
* @since 2022-10-28
* @author wj_tams_dev01
* */

import {CmApiPrefix} from '~/utils/restApi'

const urlPrefix = `${CmApiPrefix}/sdwan/profile/default-policy`

export const state = () => ({
  defaultPolicyList: [] // 기본 설정 프로파일 리스트
})

export const mutations = {
  init (state) {
    state.defaultPolicyList = []
  },

  initDefaultPolicyList (state, defaultPolicyList) {
    if (_.isArray(defaultPolicyList)) {
      state.defaultPolicyList = defaultPolicyList
    } else {
      state.defaultPolicyList = []
    }
  }
}

export const actions = {

  /* SD-WAN 기본설정 프로파일 전체목록 조회 */
  async getDefaultPolicyList ({commit}, {loading = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/0`, {loading})
      if (code === 'ok') {
        commit('initDefaultPolicyList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* SD-WAN 기본설정 프로파일 추가 */
  async addDefaultPolicy ({commit, state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post(`${urlPrefix}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* SD-WAN 기본설정 프로파일 수정(편집) */
  async updateDefaultPolicy ({state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {
        code, result
      } = await this.$axios.$put(`${urlPrefix}/${param.sdwan_default_policy_id}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* SD-WAN 기본설정 프로파일 테이블에서 직접 기본값 수정(편집) */
  async updateDefaultRadioBtn ({state}, {param, loading = false, successAlert = false} = {}) {
    let res = {code: 'ok'}
    try {
      const {
        code, result
      } = await this.$axios.$put(`${urlPrefix}/${param.sdwan_default_policy_id}/default`, {sdwan_default_policy_default: 1}, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* SD-WAN 기본설정 프로파일 삭제 */
  async delDefaultPolicy ({state}, {param}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$delete(`${urlPrefix}`, {data: param, successAlert: false, loading: false})
      if (code !== 'ok') {
        if (result.msg === undefined) {
          res = {code: 'nok', reason: '', result: result}
        } else {
          res = {code: 'nok', reason: result.msg, result: result}
        }
      } else {
        res = {code: 'ok', result: result}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* SD-WAN 기본설정 프로파일 적용/취소 */
  async finalCommand ({state}, type) {
    let res = {code: 'ok'}
    const apiUri = `${urlPrefix}/${type}`,
      axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
    try {
      const result = await this.$axios.$put(apiUri, void 0, axiosConfig)
      res = result
    } catch (e) {
      res = {code: 'nok', result: {msg: e}}
    }
    return res
  }
}
